(function () {
  'use strict';

  // Quote dialogs: any [data-open-quote] opens the dialog; product/variant passed through.
  function openQuote(trigger) {
    var dlg = document.getElementById('quote-dialog');
    if (!dlg) { window.location.href = (window.MAXV && window.MAXV.quoteUrl) || '/pages/contact-us#quote'; return; }
    var variantSel = document.querySelector('[data-quote-variant-source]');
    var hidden = dlg.querySelector('[data-quote-variant]');
    if (variantSel && hidden) hidden.value = variantSel.options[variantSel.selectedIndex].text;
    if (typeof dlg.showModal === 'function') { dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    var first = dlg.querySelector('input:not([type=hidden])');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-quote]');
    if (t) { e.preventDefault(); openQuote(t); return; }
    var c = e.target.closest('[data-close-dialog]');
    if (c) { var d = c.closest('dialog'); if (d) d.close(); }
  });
  document.querySelectorAll('dialog.modal').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    if (d.hasAttribute('data-autoopen') || d.querySelector('.form-success, .form-errors')) {
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    }
  });

  // Gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.srcset = '';
        main.alt = btn.getAttribute('data-alt') || '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + (b.getAttribute('data-qty') === 'up' ? 1 : -1);
    input.value = Math.max(parseInt(input.min || '1', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Variant select: update price + availability for buy-online products
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    var form = sel.closest('form') || document;
    var dataEl = document.getElementById(sel.getAttribute('data-variant-select'));
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var priceEl = document.querySelector('[data-price]');
    var btn = form.querySelector('[data-add-btn]');
    sel.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === sel.value; });
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (v.image && document.querySelector('[data-gallery-main]')) document.querySelector('[data-gallery-main]').src = v.image;
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    });
  });

  // Quote-mode variant select: update displayed price only
  document.querySelectorAll('[data-quote-variant-source]').forEach(function (sel) {
    var priceEl = document.querySelector('[data-price]');
    sel.addEventListener('change', function () {
      var p = sel.options[sel.selectedIndex].getAttribute('data-price-label');
      if (priceEl && p) priceEl.textContent = p;
    });
  });

  // Collection sort
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page'); window.location.href = url.toString();
    });
  });

  // Mobile drawer closes on link tap
  document.querySelectorAll('.drawer a').forEach(function (a) {
    a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.removeAttribute('open'); });
  });

  // Desktop dropdown keyboard / touch
  document.querySelectorAll('.nav__drop > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = b.parentElement; var open = p.classList.toggle('is-open'); b.setAttribute('aria-expanded', open);
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.nav__drop.is-open').forEach(function (d) { if (!d.contains(e.target)) { d.classList.remove('is-open'); d.querySelector('button').setAttribute('aria-expanded', 'false'); } });
  });

  // Collection description read-more
  document.querySelectorAll('[data-clamp]').forEach(function (el) {
    var btn = el.parentElement.querySelector('[data-clamp-toggle]');
    if (!btn) return;
    if (el.scrollHeight > el.clientHeight + 4) btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-open');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
  });

  // Guidance link preselects "help me choose"
  if (/[?&]guidance=1/.test(window.location.search)) {
    document.querySelectorAll('select[name="contact[Interested in]"]').forEach(function (s) { s.selectedIndex = 0; });
    var h = document.querySelector('#quote .form-card h2'); if (h) h.textContent = 'Get guidance';
  }

  // Tabs (marketing samples)
  document.querySelectorAll('[data-tabs]').forEach(function (t) {
    t.querySelectorAll('[data-tab]').forEach(function (b) {
      b.addEventListener('click', function () {
        t.querySelectorAll('[data-tab]').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        t.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== b.getAttribute('data-tab'); });
      });
    });
  });

  // Reveal on scroll
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
